import { render, staticRenderFns } from "./receipt_settings.vue?vue&type=template&id=64ba2bd9&"
import script from "./receipt_settings.vue?vue&type=script&lang=js&"
export * from "./receipt_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports